
const IconTextComponent = ({icon, text}) => {
  return (
        <div className="flex items-center text-white font-bold">
                {icon} {text}
        </div>
  )
}

export default IconTextComponent